/**
 * CMS API Helpers
 * Fetches content dynamically from the public CMS endpoints.
 */

const BASE_URL = 'https://api.dev.auxo.dk/public';

/**
 * Fetches all items from a collection.
 * Uses the simple array endpoint.
 * @param {string} collectionName 
 * @returns {Promise<Array>}
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/content/${collectionName}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch collection ${collectionName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Fetch Error (${collectionName}):`, error);
    return [];
  }
}

/**
 * Fetches a single page by its page_slug field.
 * @param {string} slug 
 * @returns {Promise<Object|null>}
 */
export async function fetchPageBySlug(slug) {
  try {
    const pages = await fetchCollection('pages');
    const page = pages.find(p => p.page_slug === slug);
    return page || null;
  } catch (error) {
    console.error(`CMS Fetch Page Error (${slug}):`, error);
    return null;
  }
}

/**
 * Fetches a single gallery by its gallery_slug field.
 * @param {string} slug 
 * @returns {Promise<Object|null>}
 */
export async function fetchGalleryBySlug(slug) {
  try {
    const galleries = await fetchCollection('galleri');
    const gallery = galleries.find(g => g.gallery_slug === slug);
    return gallery || null;
  } catch (error) {
    console.error(`CMS Fetch Gallery Error (${slug}):`, error);
    return null;
  }
}
